module.exports = __webpack_public_path__ + "img/background-purple-line.48a316c8.png";